import React from "react";
import { useAppSelector } from "../../../../../redux/hooks";
import { rootState } from "../../../../../redux/store";
import { OverviewJsonToTables } from "./OverviewJsonToTables";
import { DashboardLayout } from "../../DashboardLayout";
import { Spacing } from "../../../../layout/Spacing/Spacing";
import { FlexCenter } from "../../../../layout/FlexCenter/FlexCenter";
import { Loader } from "../../../../shared/Loader/Loader";
import { IPassengerTable } from "../../../../../interface/interfaces";
import { isValidPassengerData } from "./utils/isValidPassengerData";



// test data, multiple table
const data: IPassengerTable[] = [
    {
      Description: "This is a sample description 01.",
      Content:{
        name: "John",
        age: 30,
        city: "New York",
        friend: {
          name: "John",
          surname: "Doe",
          friendJob: {
            jobTitle: "IT",
            salary: 21200,
          },
        },
      }
    },
    {
      Description: "This is a sample description 02.",
      Content:{
        title: "Project A",
        status: "Active",
        description: "This is a sample project.",
        manager: {
          name: "Alice",
          surname: "Smith",
          job: {
            title: "Manager",
            department: "HR",
          },
        },
      }
    },
  ];


export const Overview = () => {

    const {nodeInfoData, nodeInfoError, nodeInfoLoading} = useAppSelector((state:rootState)=>state.nodeInfo)



    const safeData = Array.isArray(nodeInfoData)
    ? nodeInfoData.filter(isValidPassengerData)
    : [];

    if (safeData.length === 0 && !nodeInfoLoading) {
      console.error("Invalid data from backend!", nodeInfoData);
  }

    return (
        <DashboardLayout hasScroll = {false}>
            <Spacing paddingSpacing="l" marginSpacing="none">
             {
               !nodeInfoLoading
               ?
              // <OverviewJsonToTables data={data}/>
                <OverviewJsonToTables data={nodeInfoData}/>
              :
              <Loader color="accent-green" width={24} height={24} label="Getting passengers..."/>
             }
            </Spacing>
        </DashboardLayout>
    )
}
